import React, { useState } from "react";
import {
  Form,
  Input,
  Select,
  Slider,
  Checkbox,
  InputNumber,
  Button,
  Row,
  Col,
  Icon,
  DatePicker,
  Radio,
  // TimePicker,
  Upload,
  notification,
  Alert,
  message,
  Tooltip,
  Badge,
  Modal,
} from "antd";
import TimePicker from "rc-time-picker";

import forEach from "lodash/forEach";
import map from "lodash/map";
import filter from "lodash/filter";
import get from "lodash/get";
import moment from "moment-timezone";
import { connect } from "react-redux";
import classNames from "classnames";

import Signature from "./Signature/Signature";

import classes from "./FormBuilderCustomView.css";
import {
  getRandomizationConfirmStep,
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import { logout } from "../../reducers/user/actions";
import {
  getSitesRequest,
  getFollowupsRequest,
  getUsersLight,
} from "../../api/requests";
import { withNamespaces } from "react-i18next";
import FileLink from "../../components/FileLink/FileLink";
import { range } from "../../utils/range";
import { getFormErrorMessage } from "../../utils/errorHandler";
import { Controlled as CodeMirror } from "react-codemirror2";

const timezones = require("../../utils/timezones.json");

const { Option } = Select;

const FormBuilderItem = (props) => {
  const { initialValues, itemKey, schema, ageFields, isEditable} = props;
  const { getFieldDecorator, getFieldValue } = props.form;

  let show = [];
  let required = [];

  const [isAgeFormLocked, setIsAgeFormLocked] = useState(true);

  if (schema[itemKey].conditions) {
    forEach(Object.keys(schema[itemKey].conditions), (conditionGroupKey) => {
      const groupShow = [];
      forEach(
        Object.keys(schema[itemKey].conditions[conditionGroupKey]),
        (conditionKey) => {
          const condition =
            schema[itemKey].conditions[conditionGroupKey][conditionKey];

          if (condition.operator === "notEmpty") {
            groupShow.push(!!getFieldValue(condition.fieldName));
          }
          if (condition.operator === "empty") {
            groupShow.push(!getFieldValue(condition.fieldName));
          }
          if (condition.operator === "equal") {
            groupShow.push(
              getFieldValue(condition.fieldName) === condition.value
            );
          }
          if (condition.operator === "gte") {
            groupShow.push(
              getFieldValue(condition.fieldName) > condition.value
            );
          }
          if (condition.operator === "lte") {
            groupShow.push(
              getFieldValue(condition.fieldName) < condition.value
            );
          }
        }
      );

      show.push(groupShow.every((v) => v));
    });
  }

  if (schema[itemKey].conditionsRequired) {
    forEach(
      Object.keys(schema[itemKey].conditionsRequired),
      (conditionGroupKey) => {
        const groupShow = [];
        forEach(
          Object.keys(schema[itemKey].conditionsRequired[conditionGroupKey]),
          (conditionKey) => {
            const condition =
              schema[itemKey].conditionsRequired[conditionGroupKey][
                conditionKey
              ];

            if (condition.operator === "notEmpty") {
              groupShow.push(!!getFieldValue(condition.fieldName));
            }
            if (condition.operator === "empty") {
              groupShow.push(!getFieldValue(condition.fieldName));
            }
            if (condition.operator === "equal") {
              groupShow.push(
                getFieldValue(condition.fieldName) === condition.value
              );
            }
            if (condition.operator === "gte") {
              groupShow.push(
                getFieldValue(condition.fieldName) > condition.value
              );
            }
            if (condition.operator === "lte") {
              groupShow.push(
                getFieldValue(condition.fieldName) < condition.value
              );
            }
          }
        );

        required.push(groupShow.every((v) => v));
      }
    );
  }

  const isRequired = required.some((v) => v) || schema[itemKey].isRequired;

  let initialValue = get(initialValues, `${schema[itemKey].fieldName}`);
  let compareValue;
  let compareValueRender;
  if (props.compareValues) {
    if (schema[itemKey].type === "InputDateTimepicker") {
      const value = get(
        props.compareValues,
        `${schema[itemKey].fieldName}`,
        ""
      );
      compareValue = value ? value.replace(" ", "T") : "";
      initialValue = (initialValue || "").replace(" ", "T");

      compareValueRender =
        moment
          .utc(compareValue)
          .tz(props.userTimezone || get(props, "site.time_zone") || "UTC")
          .format("YYYY/MM/DD HH:mm") +
        ` ${props.userTimezone || get(props, "site.time_zone") || "UTC"}`;
    } else if (schema[itemKey].type === "DateDeltaMinutesField") {
      compareValue = get(props.compareValues, `${schema[itemKey].fieldName}`);
      compareValueRender = compareValue;
    } else {
      compareValue = get(props.compareValues, `${schema[itemKey].fieldName}`);
      compareValueRender = compareValue;
    }
  }

  const validations = [];
  const softValidations = {};

  if (schema[itemKey].hardValidation) {
    forEach(
      Object.keys(schema[itemKey].hardValidation),
      (conditionGroupKey) => {
        forEach(
          Object.keys(schema[itemKey].hardValidation[conditionGroupKey]),
          (conditionKey) => {
            const condition =
              schema[itemKey].hardValidation[conditionGroupKey][conditionKey];

            if (condition.operator === "equal") {
              validations.push({
                validator: (rule, value, callback) => {
                  if (value) {
                    try {
                      if (schema[itemKey].type === "InputCheckboxGroup") {
                        if (
                          value.filter((x) =>
                            condition.value
                              .replace(/ /g, "")
                              .split(",")
                              .includes(x)
                          ).length !== condition.value.split(",").length
                        ) {
                          throw new Error();
                        }
                        callback();
                      } else {
                        if (
                          !condition.value
                            .replace(/ /g, "")
                            .split(",")
                            .includes(value)
                        ) {
                          throw new Error();
                        }
                        callback();
                      }
                    } catch (err) {
                      callback(err);
                    }
                  } else {
                    callback();
                  }
                },
                message:
                  schema[itemKey].type === "InputCheckboxGroup"
                    ? `Must include: "${condition.value.replace(
                        /,/g,
                        '" and "'
                      )}"`
                    : `Accepted values: "${condition.value.replace(
                        /,/g,
                        '" or "'
                      )}"`,
              });
            }

            if (condition.operator === "gte") {
              validations.push({
                validator: (rule, value, callback) => {
                  if (
                    (value || value === 0) &&
                    Number.isInteger(+value) &&
                    condition.value
                  ) {
                    try {
                      if (+value < condition.value) {
                        throw new Error();
                      }
                      callback();
                    } catch (err) {
                      callback(err);
                    }
                  } else {
                    callback();
                  }
                },
                message: `Min value is ${condition.value}`,
              });
            }

            if (condition.operator === "lte") {
              validations.push({
                validator: (rule, value, callback) => {
                  if (
                    (value || value === 0) &&
                    Number.isInteger(+value) &&
                    condition.value
                  ) {
                    try {
                      if (+value > condition.value) {
                        throw new Error();
                      }
                      callback();
                    } catch (err) {
                      callback(err);
                    }
                  } else {
                    callback();
                  }
                },
                message: `Max value is ${condition.value}`,
              });
            }
          }
        );
      }
    );
  }

  if (schema[itemKey].softValidation) {
    forEach(
      Object.keys(schema[itemKey].softValidation),
      (conditionGroupKey) => {
        forEach(
          Object.keys(schema[itemKey].softValidation[conditionGroupKey]),
          (conditionKey) => {
            const condition =
              schema[itemKey].softValidation[conditionGroupKey][conditionKey];

            if (condition.operator === "empty") {
              softValidations["empty"] = true;
            }
            if (condition.operator === "notEmpty") {
              softValidations["notEmpty"] = true;
            }

            if (condition.operator === "equal") {
              softValidations["equal"] = condition.value;
            }

            if (condition.operator === "gte") {
              softValidations["gte"] = condition.value;
            }

            if (condition.operator === "lte") {
              softValidations["lte"] = condition.value;
            }
          }
        );
      }
    );
  }

  const onChangeLinkedAgeField = (value) => {
    const currentFieldName = schema[itemKey].fieldName;
    const relatedAgeFieldName = get(ageFields, currentFieldName);
    if (relatedAgeFieldName) {
      let date_to_field = null;

      forEach(Object.keys(props.schema), ((key) => {
        if (props.schema[key].fieldName === relatedAgeFieldName) {
          date_to_field = props.schema[key].date_to_field;
        }
      }));

      let age;

      let dateFrom = null;
      let dateTo = null;

      // get FROM date for age calculation
      if (value && String(value).length <= 5){
        // compare as year
        dateFrom = moment(value, "YYYY");
      } else if (value) {
        // compare as a full date in moment
        dateFrom = moment(value);
      }

      // get TO date for age calculation

      if (date_to_field && props.relatedSubjectData && get(props.relatedSubjectData, date_to_field)) {
        dateTo = moment(get(props.relatedSubjectData, date_to_field));
      } else {
        dateTo = moment();
      }


      if (dateFrom && dateTo){
        age = dateTo.diff(dateFrom, "years")
      }


      props.form.setFieldsValue({
        [relatedAgeFieldName]: Number.isInteger(age) ? age : null,
      });

      props.form.validateFields([
        relatedAgeFieldName,
      ]);
    }
  }

  return !show.length || show.some((v) => v) ? (
    <div className={classes.builderForm}>
      <div>
        {get(schema[itemKey], `HtmlBeforeContent`) && (
          <div
            dangerouslySetInnerHTML={{
              __html: get(schema[itemKey], `HtmlBeforeContent`),
            }}
          />
        )}
        {schema[itemKey].type === "InputDateTimepicker" && (
          <div>
            {isRequired && <span style={{ color: "#f5222d" }}>* &nbsp;</span>}{" "}
            {schema[itemKey].label}
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                marginTop: "4px",
              }}
            >
              <div style={{ width: "150px" }}>
                <Form.Item
                 onChange={onChangeLinkedAgeField}
                >
                  {getFieldDecorator(`${schema[itemKey].fieldName}_date`, {
                    rules: [
                      {
                        required: isRequired,
                        message: "Required",
                      },
                    ],
                    initialValue: get(
                      initialValues,
                      `${schema[itemKey].fieldName}`
                    )
                      ? moment
                          .utc(
                            get(initialValues, `${schema[itemKey].fieldName}`)
                          )
                          .tz(
                            props.userTimezone ||
                              get(props, "site.time_zone") ||
                              "UTC"
                          )
                      : null,
                  })(
                    <DatePicker
                      disabled={
                        !isEditable ||
                        schema[itemKey].disabled ||
                        schema[itemKey].readonly
                      }
                      format="YYYY/MM/DD"
                      placeholder="YYYY/MM/DD"
                      disabledDate={(currentDate) => {
                        if (
                          schema[itemKey].disable_future_dates ||
                          !isNaN(schema[itemKey].max_minutes_before_now)
                        ) {
                          const now = props.getNow();
                          let nowMin;

                          if (!isNaN(schema[itemKey].max_minutes_before_now)) {
                            nowMin = props
                              .getNow()
                              .subtract(
                                schema[itemKey].max_minutes_before_now,
                                "m"
                              );
                          }

                          return (
                            (schema[itemKey].disable_future_dates
                              ? moment(currentDate.format("YYYY-MM-DD")) >
                                moment(
                                  moment(now.format("YYYY-MM-DDTHH:mm")).format(
                                    "YYYY-MM-DD"
                                  )
                                )
                              : false) ||
                            (nowMin
                              ? moment(currentDate.format("YYYY-MM-DD")) <
                                moment(nowMin.format("YYYY-MM-DD"))
                              : false)
                          );
                        }
                      }}
                      onChange={() => {
                        props.form.setFieldsValue({
                          [`${schema[itemKey].fieldName}_time`]: undefined,
                        });
                      }}
                      showToday={false}
                    />
                  )}
                </Form.Item>
              </div>
              &nbsp;&nbsp;
              <div style={{ width: "100px" }}>
                <Form.Item>
                  {getFieldDecorator(`${schema[itemKey].fieldName}_time`, {
                    rules: [
                      {
                        required: isRequired,
                        message: "Required",
                      },
                    ],
                    initialValue: get(
                      initialValues,
                      `${schema[itemKey].fieldName}`
                    )
                      ? moment
                          .utc(
                            get(initialValues, `${schema[itemKey].fieldName}`)
                          )
                          .tz(
                            props.userTimezone ||
                              get(props, "site.time_zone") ||
                              "UTC"
                          )
                      : null,
                  })(
                    <TimePicker
                      disabled={
                        !isEditable ||
                        schema[itemKey].disabled ||
                        schema[itemKey].readonly ||
                        !moment(
                          getFieldValue(`${schema[itemKey].fieldName}_date`)
                        ).date()
                      }
                      inputReadOnly
                      format="HH:mm"
                      showSecond={false}
                      placeholder="HH:mm"
                      showToday={false}
                      disabledHours={() => {
                        const selectedDate = moment(
                          getFieldValue(`${schema[itemKey].fieldName}_date`)
                        ).date();

                        const now = moment(
                          props.getNow().format("YYYY-MM-DDTHH:mm")
                        );
                        let nowMin;
                        const currentTimeDate = now.date();
                        const currentTimeHour = now.hour();

                        if (!isNaN(schema[itemKey].max_minutes_before_now)) {
                          nowMin = props
                            .getNow()
                            .subtract(
                              schema[itemKey].max_minutes_before_now,
                              "m"
                            );
                        }

                        if (schema[itemKey].disable_future_dates) {
                          if (
                            nowMin &&
                            currentTimeDate === selectedDate &&
                            nowMin.date() === selectedDate
                          ) {
                            if (currentTimeDate === selectedDate) {
                              return [
                                ...range(0, nowMin.hour()),
                                ...range(currentTimeHour + 1, 25),
                              ];
                            }
                          }

                          if (currentTimeDate === selectedDate) {
                            return [...range(currentTimeHour + 1, 25)];
                          }
                        }

                        if (!isNaN(schema[itemKey].max_minutes_before_now)) {
                          if (nowMin.date() === selectedDate) {
                            return range(0, nowMin.hour());
                          }
                        }
                      }}
                      disabledMinutes={() => {
                        const now = moment(
                          props.getNow().format("YYYY-MM-DDTHH:mm")
                        );
                        const selectedDate = getFieldValue(
                          `${schema[itemKey].fieldName}_date`
                        );
                        const selectedTime = getFieldValue(
                          `${schema[itemKey].fieldName}_time`
                        );

                        if (schema[itemKey].disable_future_dates) {
                          if (
                            selectedTime &&
                            now.date() === selectedDate.date() &&
                            selectedTime.hour() === now.hour()
                          ) {
                            return range(now.minute() + 1, 60);
                          }

                          if (!selectedTime) {
                            return range(0, 60);
                          }
                        }

                        if (!isNaN(schema[itemKey].max_minutes_before_now)) {
                          const nowMin = props
                            .getNow()
                            .subtract(
                              schema[itemKey].max_minutes_before_now,
                              "m"
                            );

                          if (
                            selectedTime &&
                            nowMin.date() === selectedDate.date() &&
                            selectedTime.hour() === nowMin.hour()
                          ) {
                            return range(0, nowMin.minute());
                          }

                          if (!selectedTime) {
                            return range(0, 60);
                          }
                        }
                      }}
                    />
                  )}
                </Form.Item>
              </div>
              &nbsp;
              <p style={{ padding: "0 0 18px 30px" }}>
                {props.userShortTimezone ||
                  get(props, "site.time_zone") ||
                  "UTC"}
              </p>
            </div>
          </div>
        )}

        {!["Text", "InputDateTimepicker"].includes(schema[itemKey].type) && (
          <Form.Item label={schema[itemKey].label} required={isRequired}>
            {schema[itemKey].type === "InputNumber" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue:
                  !isNaN(get(initialValues, `${schema[itemKey].fieldName}`)) &&
                  get(initialValues, `${schema[itemKey].fieldName}`) !== null
                    ? +get(initialValues, `${schema[itemKey].fieldName}`)
                    : null,
              })(
                <InputNumber
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                  onChange={onChangeLinkedAgeField}
                />
              )}

            {schema[itemKey].type === "DateDeltaMinutesField" && (
              <div>
                {(() => {
                  let dateFrom;
                  const dateFromFieldName = schema[itemKey].date_from;
                  const dateToFieldName = schema[itemKey].date_to;
                  let val;
                  let now;
                  if (
                    dateToFieldName === "randomization_time" &&
                    initialValues &&
                    initialValues.created
                  ) {
                    now = moment(initialValues.created)
                      .utc()
                      .tz(
                        props.userTimezone ||
                          get(props, "site.time_zone") ||
                          "UTC"
                      );
                  } else {
                    now = props.getNow();
                  }

                  if (
                    getFieldValue(`${dateFromFieldName}_date`) &&
                    getFieldValue(`${dateFromFieldName}_time`)
                  ) {
                    dateFrom = moment(
                      `${getFieldValue(`${dateFromFieldName}_date`).format(
                        "YYYY-MM-DD"
                      )} ${getFieldValue(`${dateFromFieldName}_time`).format(
                        "HH:mm"
                      )}`
                    ).tz(
                      props.userTimezone ||
                        get(props, "site.time_zone") ||
                        "UTC"
                    );
                  }

                  if (dateToFieldName === "randomization_time") {
                    if (initialValues && initialValues.created) {
                      val = now.diff(dateFrom, "minutes") + now._offset;
                    } else {
                      val = now.diff(dateFrom, "minutes");
                    }
                  } else {
                    let dateTo;

                    if (
                      getFieldValue(`${dateToFieldName}_date`) &&
                      getFieldValue(`${dateToFieldName}_time`)
                    ) {
                      dateTo = moment(
                        `${getFieldValue(`${dateToFieldName}_date`).format(
                          "YYYY-MM-DD"
                        )} ${getFieldValue(`${dateToFieldName}_time`).format(
                          "HH:mm"
                        )}`
                      ).tz(
                        props.userTimezone ||
                          get(props, "site.time_zone") ||
                          "UTC"
                      );

                      val = dateTo.diff(dateFrom, "minutes");
                    }
                  }

                  return (
                    <Input
                      disabled
                      value={
                        dateFrom && val === 0
                          ? 0
                          : val ||
                            get(initialValues, `${schema[itemKey].fieldName}`)
                      }
                    />
                  );
                })()}
              </div>
            )}

            {schema[itemKey].type === "AgeFromField" && (
              <div className={classNames('ant-input-wrapper ant-input-group addonAfterInput', classes.ageFromFieldWrapper)}>
                {getFieldDecorator(schema[itemKey].fieldName, {
                  initialValue: get(
                    initialValues,
                    `${schema[itemKey].fieldName}`
                  ),
                  rules: [...validations],
                })(
                  <InputNumber
                    disabled={isAgeFormLocked}
                    placeholder={schema[itemKey].placeholder}
                  />
                )}
                {get(schema[itemKey], "can_be_unlocked") && (
                  <button type="button" className={classNames("ant-input-group-addon", classes.ageFromFieldButton)} onClick={() => {
                    setIsAgeFormLocked(!isAgeFormLocked)
                  }}>
                    {isAgeFormLocked ? <Icon type="lock" /> : <Icon type="unlock" />}
                  </button>
                )}
              </div>
            )}

            {schema[itemKey].type === "InputDatePicker" && (
              <div style={{ display: "flex", alignItems: "center" }}>
                {getFieldDecorator(schema[itemKey].fieldName, {
                  rules: [
                    {
                      required: isRequired,
                      message: "Required",
                    },
                  ],
                  initialValue: get(
                    initialValues,
                    `${schema[itemKey].fieldName}`
                  )
                    ? moment
                        .utc(get(initialValues, `${schema[itemKey].fieldName}`))
                        .tz(
                          props.userTimezone ||
                            get(props, "site.time_zone") ||
                            "UTC"
                        )
                    : null,
                })(
                  <DatePicker
                    disabled={
                      !isEditable ||
                      schema[itemKey].disabled ||
                      schema[itemKey].readonly
                    }
                    format="YYYY/MM/DD"

                    onChange={onChangeLinkedAgeField}
                  />
                )}
                &nbsp;
                {props.userShortTimezone ||
                  get(props, "site.time_zone") ||
                  "UTC"}
              </div>
            )}

            {schema[itemKey].type === "InputText" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue:
                  get(initialValues, `${schema[itemKey].fieldName}`) ||
                  schema[itemKey].default_value,
              })(
                <Input
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                />
              )}

            {schema[itemKey].type === "InputEmail" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  {
                    type: "email",
                    message: "The input is not valid email",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <Input
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                />
              )}

            {schema[itemKey].type === "InputTextArea" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <Input.TextArea
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                />
              )}

            {schema[itemKey].type === "HTMLBlock" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <CodeMirror
                  value={get(initialValues, `${schema[itemKey].fieldName}`)}
                  options={{
                    mode: "html",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              )}

            {schema[itemKey].type === "HtmlDisplayBlock" &&
              get(schema[itemKey], `HtmlContent`) && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: get(schema[itemKey], `HtmlContent`),
                  }}
                />
              )}

            {schema[itemKey].type === "InputMonthPicker" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                ],
                initialValue: get(initialValues, `${schema[itemKey].fieldName}`)
                  ? moment(get(initialValues, `${schema[itemKey].fieldName}`))
                  : null,
              })(
                <DatePicker.MonthPicker
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                  allowClear
                  onChange={(value) => {
                    if (ageFields[schema[itemKey].fieldName]) {
                      const age = moment().diff(value, "years");
                      props.form.setFieldsValue({
                        [ageFields[
                          schema[itemKey].fieldName
                        ]]: Number.isInteger(age) ? age : null,
                      });

                      props.form.validateFields([
                        ageFields[schema[itemKey].fieldName],
                      ]);
                    }
                  }}
                />
              )}

            {schema[itemKey].type === "InputTimePicker" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <TimePicker
                  inputReadOnly
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                  allowClear
                  format="HH:mm"
                  showSecond={false}
                  disabledSeconds
                  showToday={false}
                />
              )}

            {schema[itemKey].type === "InputCheckbox" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                ],
                valuePropName: "checked",
                initialValue:
                  get(initialValues, `${schema[itemKey].fieldName}`) || false,
              })(
                <Checkbox
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                >
                  {schema[itemKey].placeholder}
                </Checkbox>
              )}

            {schema[itemKey].type === "InputSelect" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <Select
                  placeholder={schema[itemKey].placeholder}
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  allowClear
                >
                  {map(schema[itemKey].options.split(","), (opt, i) => (
                    <Option value={opt.split(":")[0].trim()} key={i}>
                      {opt.split(":")[1]}
                    </Option>
                  ))}
                </Select>
              )}

            {schema[itemKey].type === "InputTimezone" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <Select
                  placeholder={schema[itemKey].placeholder}
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                >
                  <Option value="">None</Option>
                  {timezones.map(({ utc }) =>
                    utc.map((tz, i) => (
                      <Option value={tz} key={i}>
                        {tz}
                      </Option>
                    ))
                  )}
                </Select>
              )}

            {schema[itemKey].type === "InputSecureText" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <Input.Password
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                  autoComplete="new-password"
                />
              )}

            {["InputRadioGroup"].includes(schema[itemKey].type) &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <Radio.Group
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                >
                  {map(schema[itemKey].options.split(","), (opt, i) => (
                    <div key={i}>
                      <Radio value={opt.split(":")[0].trim()}>
                        {opt.split(":")[1]}
                      </Radio>
                    </div>
                  ))}
                </Radio.Group>
              )}

            {["InputRadioBooleanGroup"].includes(schema[itemKey].type) &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <Radio.Group
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                >
                  {map(schema[itemKey].options.split(","), (opt, i) => (
                    <div key={i}>
                      <Radio
                        value={
                          opt.split(":")[0].trim().toLowerCase() === "true"
                        }
                      >
                        {opt.split(":")[1]}
                      </Radio>
                    </div>
                  ))}
                </Radio.Group>
              )}

            {schema[itemKey].type === "InputCheckboxGroup" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                  ...validations,
                ],
                initialValue: get(
                  initialValues,
                  `${schema[itemKey].fieldName}`
                ),
              })(
                <Checkbox.Group
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  options={
                    schema[itemKey].options
                      ? map(schema[itemKey].options.split(","), (opt, i) => ({
                          label: opt.split(":")[1],
                          value: opt.split(":")[0].trim(),
                        }))
                      : []
                  }
                />
              )}

            {schema[itemKey].type === "InputSlider" && (
              <div
                style={{
                  height: schema[itemKey].isSliderVertical ? "200px" : "auto",
                }}
              >
                {getFieldDecorator(schema[itemKey].fieldName, {
                  rules: [
                    {
                      required: isRequired,
                      message: "Required",
                    },
                  ],
                  initialValue:
                    get(initialValues, `${schema[itemKey].fieldName}`) || 0,
                })(
                  <Slider
                    disabled={
                      !isEditable ||
                      schema[itemKey].disabled ||
                      schema[itemKey].readonly
                    }
                    type="number"
                    min={+schema[itemKey].min}
                    max={+schema[itemKey].max}
                    vertical={!!schema[itemKey].isSliderVertical}
                    marks={(() => {
                      const marksObj = {};
                      const marks = schema[itemKey].marks;

                      if (marks) {
                        try {
                          forEach(marks.split(","), (opt) => {
                            const option = opt.split(":");
                            if (option[0] && option[1]) {
                              marksObj[option[0].trim()] = option[1];
                            }
                          });
                        } catch (e) {}
                      }
                      return marksObj;
                    })()}
                  />
                )}
              </div>
            )}

            {schema[itemKey].type === "InputSignature" && (
              <div>
                <Signature
                  fromDataURL={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                      ? get(initialValues, `${schema[itemKey].fieldName}`)
                      : null
                  }
                  fieldName={schema[itemKey].fieldName}
                  form={props.form}
                  isRequired={isRequired}
                  isPreview={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  // isPreview={props.isPreview}
                />
              </div>
            )}

            {schema[itemKey].type === "InputUpload" && (
              <div>
                <Form.Item>
                  {getFieldDecorator(schema[itemKey].fieldName, {
                    initialValue: get(
                      this.props,
                      schema[itemKey].fieldName,
                      ""
                    ),
                  })(
                    <Upload
                      disabled={
                        !isEditable ||
                        schema[itemKey].disabled ||
                        schema[itemKey].readonly
                      }
                      accept=".doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.mp4"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        props.form.getFieldValue(schema[itemKey].fieldName),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!props.form.getFieldValue(schema[itemKey].fieldName) &&
                        props.url
                          ? props.i18n.t("Change file")
                          : props.i18n.t(
                              "NamespaceDocumentsEditor:Add New Document"
                            )}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>

                {!props.form.getFieldValue(schema[itemKey].fieldName) &&
                  get(initialValues, `${schema[itemKey].fieldName}`) && (
                    <div>
                      <FileLink
                        url={get(initialValues, `${schema[itemKey].fieldName}`)}
                        text="File preview"
                      />
                    </div>
                  )}
              </div>
            )}

            {schema[itemKey].type === "InputSelectSiteID" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                ],
                initialValue: get(initialValues, `${schema[itemKey].fieldName}`)
                  ? get(
                      initialValues,
                      `${schema[itemKey].fieldName}`,
                      undefined
                    )
                  : undefined,
              })(
                <Select
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                  style={{ width: "100%" }}
                  allowClear
                >
                  {props.sites.map((site) => (
                    <Option key={site.id} value={site.id}>
                      {site.name}
                    </Option>
                  ))}
                </Select>
              )}

            {schema[itemKey].type === "InputSelectFollowUpID" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                ],
                initialValue: get(initialValues, `${schema[itemKey].fieldName}`)
                  ? get(
                      initialValues,
                      `${schema[itemKey].fieldName}`,
                      undefined
                    )
                  : undefined,
              })(
                <Select
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                  style={{ width: "100%" }}
                  allowClear
                >
                  {props.followups.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              )}

            {schema[itemKey].type === "InputSelectUserID" &&
              getFieldDecorator(schema[itemKey].fieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: "Required",
                  },
                ],
                initialValue: get(initialValues, `${schema[itemKey].fieldName}`)
                  ? get(
                      initialValues,
                      `${schema[itemKey].fieldName}`,
                      undefined
                    )
                  : undefined,
              })(
                <Select
                  disabled={
                    !isEditable ||
                    schema[itemKey].disabled ||
                    schema[itemKey].readonly
                  }
                  placeholder={schema[itemKey].placeholder}
                  style={{ width: "100%" }}
                  allowClear
                >
                  {props.users.map((user) => (
                    <Option key={user.id} value={user.id}>
                      {user.username}
                    </Option>
                  ))}
                </Select>
              )}

            {!!(
              !isNaN(getFieldValue(schema[itemKey].fieldName)) &&
              softValidations.lte &&
              !!(
                getFieldValue(schema[itemKey].fieldName) ||
                getFieldValue(schema[itemKey].fieldName) === 0
              ) &&
              getFieldValue(schema[itemKey].fieldName) > softValidations.lte
            ) && (
              <Alert
                className="softValidations"
                type="warning"
                message={`Are you sure ${schema[itemKey].label} is above ${softValidations.lte}?`}
              />
            )}

            {!!(
              !isNaN(getFieldValue(schema[itemKey].fieldName)) &&
              softValidations.gte &&
              !!(
                getFieldValue(schema[itemKey].fieldName) ||
                getFieldValue(schema[itemKey].fieldName) === 0
              ) &&
              getFieldValue(schema[itemKey].fieldName) < softValidations.gte
            ) && (
              <Alert
                className="softValidations"
                type="warning"
                message={`Are you sure ${schema[itemKey].label} is below ${softValidations.gte}?`}
              />
            )}

            {(getFieldValue(schema[itemKey].fieldName) ||
              !isNaN(getFieldValue(schema[itemKey].fieldName))) &&
              softValidations.equal &&
              `${getFieldValue(schema[itemKey].fieldName)}` !==
                `${softValidations.equal}` && (
                <Alert
                  className="softValidations"
                  type="warning"
                  message={`Are you sure ${schema[itemKey].label} is not equal to ${softValidations.equal}?`}
                />
              )}

            {(getFieldValue(schema[itemKey].fieldName) ||
              !isNaN(getFieldValue(schema[itemKey].fieldName))) &&
              softValidations.empty && (
                <Alert
                  className="softValidations"
                  type="warning"
                  message={`Are you sure ${schema[itemKey].label} is not empty?`}
                />
              )}

            {!getFieldValue(schema[itemKey].fieldName) &&
              softValidations.notEmpty && (
                <Alert
                  className="softValidations"
                  type="warning"
                  message={`Are you sure ${schema[itemKey].label} is empty?`}
                />
              )}
          </Form.Item>
        )}

        {/*{schema[itemKey].type === "AgeFromField" &&
          (getFieldValue(schema[itemKey].fieldName) ||
            getFieldValue(schema[itemKey].fieldName) === 0) &&
          (getFieldValue(schema[itemKey].fieldName) === 18 ||
            getFieldValue(schema[itemKey].fieldName) < 18 ||
            getFieldValue(schema[itemKey].fieldName) > 100) && (
            <Col md={24} style={{ paddingBottom: "10px" }}>
              {getFieldValue(schema[itemKey].fieldName) === 18 && (
                <Alert
                  type="warning"
                  message={props.i18n.t(
                    "NamespaceRandomizeFormSeparate:Please confirm this patient is truly 18 years old as of today"
                  )}
                />
              )}
              {getFieldValue(schema[itemKey].fieldName) < 18 && (
                <Alert
                  type="error"
                  message={props.i18n.t(
                    "NamespaceRandomizeFormSeparate:Randomization is not allowed for patients under 18"
                  )}
                />
              )}
              {getFieldValue(schema[itemKey].fieldName) > 100 && (
                <Alert
                  type="error"
                  message={props.i18n.t(
                    "NamespaceRandomizeFormSeparate:Birth year looks wrong"
                  )}
                />
              )}
            </Col>
          )}*/}

        {schema[itemKey].type === "Text" && <p>{schema[itemKey].text}</p>}

        {get(schema[itemKey], `HtmlAfterContent`) && (
          <div
            dangerouslySetInnerHTML={{
              __html: get(schema[itemKey], `HtmlAfterContent`),
            }}
          />
        )}

        {props.compareValues && initialValue !== compareValue && (
          <div style={{ margin: "-20px 0 20px 0" }}>
            <Alert
              type="warning"
              message={`Randomization value: ${compareValueRender}`}
            />
          </div>
        )}
      </div>
    </div>
  ) : (
    ""
  );
};

class FormBuilderCustomView extends React.Component {
  constructor(props) {
    super(props);

    const formSectionKeys = Object.keys(props.schema).sort(
      (a, b) => props.schema[a].order - props.schema[b].order
    );

    const schemaKeys = {};

    forEach(formSectionKeys, (formSectionKey) => {
      schemaKeys[formSectionKey] = Object.keys(
        get(props.schema[formSectionKey], "fields", {})
      ).sort(
        (a, b) =>
          props.schema[formSectionKey].fields[a].order -
          props.schema[formSectionKey].fields[b].order
      );
    });

    this.state = {
      formSectionKeys,
      schemaKeys,
      sites: [],
      users: [],
      followups: [],
      isLoading: false,
      showConfirmModal: false,
    };
  }

  componentDidMount() {
    moment.tz.setDefault(
      this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
    );

    if (
      Object.keys(this.props.schema).some((sectionKey) => {
        return Object.keys(this.props.schema[sectionKey].fields || {}).some(
          (itemKey) =>
            this.props.schema[sectionKey].fields[itemKey].type ===
            "InputSelectSiteID"
        );
      })
    ) {
      this.getSites();
    }

    if (
      Object.keys(this.props.schema).some((sectionKey) => {
        return Object.keys(this.props.schema[sectionKey].fields || {}).some(
          (itemKey) =>
            this.props.schema[sectionKey].fields[itemKey].type ===
            "InputSelectFollowUpID"
        );
      })
    ) {
      this.getFollowups();
    }

    if (
      Object.keys(this.props.schema).some((sectionKey) => {
        return Object.keys(this.props.schema[sectionKey].fields || {}).some(
          (itemKey) =>
            this.props.schema[sectionKey].fields[itemKey].type ===
            "InputSelectUserID"
        );
      })
    ) {
      this.getUsers();
    }
  }

  getNow = () => {
    return this.props.slug === "randomization" &&
      get(this.props, "initialValues.created")
      ? moment
          .utc(get(this.props, "initialValues.created"))
          .tz(
            this.props.userTimezone ||
              get(this.props, "site.time_zone") ||
              "UTC"
          )
      : moment().tz(
          this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
        );
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.schema !== prevProps.schema &&
      Object.keys(this.props.schema).some((sectionKey) => {
        return Object.keys(this.props.schema[sectionKey].fields || {}).some(
          (itemKey) =>
            this.props.schema[sectionKey].fields[itemKey].type ===
            "InputSelectSiteID"
        );
      })
    ) {
      this.getSites();
    }
  }

  getSites = async () => {
    try {
      const { data } = await getSitesRequest();
      this.setState({
        sites: data.filter((item) => item.site_type === "randomization"),
      });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  };

  getFollowups = async () => {
    try {
      const { data } = await getFollowupsRequest(
        this.props.site && this.props.site.id
      );
      this.setState({
        followups: data,
      });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  };

  getUsers = async () => {
    try {
      const { data } = await getUsersLight();
      this.setState({
        users: data,
      });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, data) => {
      if (!err) {
        this.setState({
          isLoading: true,
          requestResult: null,
        });
        const values = { ...data };

        // Date transform from userTimezone to UTC
        Object.keys(this.props.schema).forEach((sectionKey) => {
          Object.keys(this.props.schema[sectionKey].fields || {}).forEach(
            (itemKey) => {
              if (this.props.schema[sectionKey].fields[itemKey].disabled) {
                const fieldName = this.props.schema[sectionKey].fields[itemKey]
                  .fieldName;
                delete values[fieldName];
              }

              if (
                this.props.schema[sectionKey].fields[itemKey].type ===
                "InputCheckboxGroup"
              ) {
                const fieldName = this.props.schema[sectionKey].fields[itemKey]
                  .fieldName;
                if (!values[fieldName]) {
                  values[fieldName] = [];
                }
              }

              if (
                this.props.schema[sectionKey].fields[itemKey].type ===
                "InputDateTimepicker"
              ) {
                const fieldName = this.props.schema[sectionKey].fields[itemKey]
                  .fieldName;

                if (
                  values[`${fieldName}_date`] &&
                  values[`${fieldName}_time`]
                ) {
                  values[fieldName] = moment(
                    `${values[`${fieldName}_date`].format(
                      "YYYY-MM-DD"
                    )}T${values[`${fieldName}_time`].format("HH:mm")}`
                  )
                    .utc()
                    .format("YYYY-MM-DDTHH:mm:ss");
                }

                delete values[`${fieldName}_date`];
                delete values[`${fieldName}_time`];
              }

              if (
                this.props.schema[sectionKey].fields[itemKey].type ===
                "InputMonthPicker"
              ) {
                const fieldName = this.props.schema[sectionKey].fields[itemKey]
                  .fieldName;

                if (values[fieldName]) {
                  values[fieldName] = moment(
                    `${values[fieldName].format("YYYY-MM")}-02`
                  ).format("YYYY-MM-DDTHH:mm:ss");
                }
              }

              if (
                this.props.schema[sectionKey].fields[itemKey].type ===
                "InputTimePicker"
              ) {
                const fieldName = this.props.schema[sectionKey].fields[itemKey]
                  .fieldName;

                if (values[fieldName]) {
                  values[fieldName] = moment(
                    `${values[fieldName].format("YYYY-MM-DD")}T${values[
                      fieldName
                    ].format("HH:mm")}`
                  ).format("YYYY-MM-DDTHH:mm:ss");
                }
              }

              if (
                this.props.schema[sectionKey].fields[itemKey].type ===
                "DateDeltaMinutesField"
              ) {
                const fieldName = this.props.schema[sectionKey].fields[itemKey]
                  .fieldName;

                let dateFrom;
                const dateFromFieldName = this.props.schema[sectionKey].fields[
                  itemKey
                ].date_from;
                const dateToFieldName = this.props.schema[sectionKey].fields[
                  itemKey
                ].date_to;
                let val;
                let now;

                if (
                  dateToFieldName === "randomization_time" &&
                  this.props.initialValues &&
                  this.props.initialValues.created
                ) {
                  now = moment(this.props.initialValues.created);
                } else {
                  now = moment();
                }

                if (
                  data[`${dateFromFieldName}_date`] &&
                  data[`${dateFromFieldName}_time`]
                ) {
                  dateFrom = moment(
                    `${data[`${dateFromFieldName}_date`].format(
                      "YYYY-MM-DD"
                    )} ${data[`${dateFromFieldName}_time`].format("HH:mm")}`
                  );
                }

                if (dateToFieldName === "randomization_time") {
                  val =
                    now.diff(dateFrom, "minutes") +
                    (get(this.props, "initialValues.created")
                      ? now._offset
                      : 0);
                } else {
                  let dateTo;

                  if (
                    data[`${dateToFieldName}_date`] &&
                    data[`${dateToFieldName}_time`]
                  ) {
                    dateTo = moment(
                      `${data[`${dateToFieldName}_date`].format(
                        "YYYY-MM-DD"
                      )} ${data[`${dateToFieldName}_time`].format("HH:mm")}`
                    );

                    val = dateTo.diff(dateFrom, "minutes");
                  }
                }

                if (val) {
                  values[fieldName] = val;
                }
              }
            }
          );
        });

        try {
          this.props.onSubmit && (await this.props.onSubmit(values));
          this.props.onFormSubmit && (await this.props.onFormSubmit());

          this.setState({
            isLoading: false,
          });

          this.setState({
            requestResult: {
              type: "success",
              message: "Saved",
            },
          });

          setTimeout(() => {
            this.setState({ requestResult: null });
          }, 1000);
        } catch (e) {
          notification.error({
            message: JSON.stringify(
              get(e, "response.data.errors", get(e, "response.data", "Error"))
            ),
          });

          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          let errorMessage = getFormErrorMessage(e);
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: errorMessage,
            },
          });

          if (get(e, "response.data")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors", [])).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: map(
                    get(e, `response.data.errors.${errorFieldKey}`, []),
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  getAgeFields = () => {
    const result = [];
    const fields = {};

    forEach(this.state.formSectionKeys, (sectionKey) => {
      forEach(this.state.schemaKeys[sectionKey], (itemKey) => {
        result.push(get(this.props.schema, `${sectionKey}.fields.${itemKey}`));
      });
    });

    forEach(
      filter(result, ({ type }) => type === "AgeFromField"),
      ({ year_from, date_from_field, fieldName }) => {
        fields[date_from_field || year_from] = fieldName;
      }
    );
    return fields;
  };

  render() {
    const { formSectionKeys, schemaKeys, isLoading } = this.state;
    const {
      schema,
      name,
      isEditable = true,
      slug,
      updatedBy,
      updatedOn,
      disabledSave,
    } = this.props;
    const {
      getFieldDecorator,
      getFieldValue,
      setFieldsValue,
    } = this.props.form;

    const fieldsError = this.props.form.getFieldsError();

    return (
      <div className={classes.formBuilder}>
        <Row gutter={8}>
          <Col span={24}>
            <Form onSubmit={this.handleSubmit}>
              {name && slug !== "randomization" && (
                <h4 className="headline">{name}</h4>
              )}

              {updatedBy && (
                <p>
                  <Badge
                    count={`Updated by: ${updatedBy}`}
                    style={{ backgroundColor: "#2968AE" }}
                  />
                  &nbsp;
                  <Badge
                    count={
                      moment
                        .utc(updatedOn)
                        .tz(
                          this.props.userTimezone ||
                            get(this.props, "site.time_zone") ||
                            "UTC"
                        )
                        .format("YYYY/MM/DD HH:mm") +
                      ` ${
                        this.props.userTimezone ||
                        get(this.props, "site.time_zone") ||
                        "UTC"
                      }`
                    }
                    style={{ backgroundColor: "#2968AE" }}
                  />
                </p>
              )}

              <Row gutter={8} type="flex">
                {this.props.preChildren &&
                  this.props.preChildren({
                    getFieldDecorator,
                    getFieldValue,
                    setFieldsValue,
                  })}
                {formSectionKeys.map((sectionKey) => (
                  <Col
                    key={sectionKey}
                    span={
                      get(schema, `${sectionKey}.column`) === "1/2" ? 12 : 24
                    }
                  >
                    {schema[sectionKey].sectionName && (
                      <h5>{schema[sectionKey].sectionName}</h5>
                    )}
                    <div className={classes.formBuilderItemsWrapper}>
                      {schemaKeys[sectionKey].map((itemKey, i) => (
                        <div
                          key={itemKey}
                          className={classNames(classes.formBuilderSection, {
                            [classes.builderFormHalf]:
                              get(
                                schema,
                                `${sectionKey}.fields.${itemKey}.column`
                              ) === "1/2",
                            [classes.builderFormThird]:
                              get(
                                schema,
                                `${sectionKey}.fields.${itemKey}.column`
                              ) === "1/3",
                          })}
                        >
                          <FormBuilderItem
                            {...this.props}
                            {...this.state}
                            disabled={!isEditable}
                            key={i}
                            getNow={this.getNow}
                            itemKey={itemKey}
                            schemaKeys={schemaKeys[sectionKey]}
                            schema={get(schema, `${sectionKey}.fields`)}
                            ageFields={this.getAgeFields()}
                          />
                        </div>
                      ))}
                    </div>
                  </Col>
                ))}
              </Row>

              {this.state.requestResult && this.state.requestResult.message && (
                <Alert
                  type={this.state.requestResult.type}
                  message={this.state.requestResult.message}
                />
              )}

              {this.props.postChildren &&
                this.props.postChildren({
                  getFieldDecorator,
                  getFieldValue,
                  setFieldsValue,
                })}

              {isEditable && !disabledSave && (
                <div className="action-wrapper">
                  <Button
                    size="large"
                    type="primary"
                    htmlType={
                      this.props.randomizationConfirmStep &&
                      slug === "randomization"
                        ? "button"
                        : "submit"
                    }
                    loading={isLoading}
                    disabled={isLoading}
                    onClick={() => {
                      if (
                        this.props.randomizationConfirmStep &&
                        slug === "randomization"
                      ) {
                        this.props.form.validateFields(async (err, data) => {
                          if (!err) {
                            this.setState({
                              showConfirmModal: true,
                            });
                          }
                        });
                      }
                    }}
                  >
                    {this.props.saveButton || "Save"}
                  </Button>

                  {this.props.backStep}
                </div>
              )}
              <Modal
                title="Confirm All Data is Correct"
                visible={this.state.showConfirmModal}
                footer={null}
                onCancel={() => {
                  this.setState({
                    showConfirmModal: false,
                  });
                }}
              >
                {formSectionKeys.map((sectionKey) =>
                  schemaKeys[sectionKey].map((itemKey, i) => (
                    <div>
                      <b>
                        {get(schema, `${sectionKey}.fields.${itemKey}.label`)}
                      </b>
                      <div style={{ paddingBottom: "8px" }}>
                        {get(schema, `${sectionKey}.fields.${itemKey}.type`) ===
                        "InputDateTimepicker"
                          ? moment(
                              getFieldValue(
                                `${get(
                                  schema,
                                  `${sectionKey}.fields.${itemKey}.fieldName`
                                )}_date`
                              )
                            ).format("YYYY-MM-DD") +
                            " " +
                            moment(
                              getFieldValue(
                                `${get(
                                  schema,
                                  `${sectionKey}.fields.${itemKey}.fieldName`
                                )}_time`
                              )
                            ).format("HH:mm")
                          : get(
                              schema,
                              `${sectionKey}.fields.${itemKey}.type`
                            ) === "InputDatePicker"
                          ? moment(
                              getFieldValue(
                                `${get(
                                  schema,
                                  `${sectionKey}.fields.${itemKey}.fieldName`
                                )}_date`
                              )
                            ).format("YYYY-MM-DD")
                          : get(
                              schema,
                              `${sectionKey}.fields.${itemKey}.fieldName`
                            )
                          ? getFieldValue(
                              get(
                                schema,
                                `${sectionKey}.fields.${itemKey}.fieldName`
                              )
                            )
                          : ""}
                      </div>

                      {fieldsError[
                        get(schema, `${sectionKey}.fields.${itemKey}.fieldName`)
                      ] && (
                        <div style={{ margin: "-8px 0 8px", color: "#f5222d" }}>
                          {Array.isArray(
                            fieldsError[
                              get(
                                schema,
                                `${sectionKey}.fields.${itemKey}.fieldName`
                              )
                            ]
                          )
                            ? fieldsError[
                                get(
                                  schema,
                                  `${sectionKey}.fields.${itemKey}.fieldName`
                                )
                              ].join("")
                            : fieldsError[
                                get(
                                  schema,
                                  `${sectionKey}.fields.${itemKey}.fieldName`
                                )
                              ]}
                        </div>
                      )}
                    </div>
                  ))
                )}

                {this.props.randomizationConfirmStep && (
                  <div>
                    <label>
                      <b>
                        Please CONFIRM that the subject meets eligibility
                        criteria, has the consent process been completed
                        according to local requirements and is ready to be
                        randomized!
                      </b>
                    </label>
                    <Form.Item>
                      {getFieldDecorator("is_correct_check", {
                        rules: [
                          {
                            required: this.state.showConfirmModal,
                            message: "Required",
                          },
                        ],
                      })(
                        <Select
                          disabled={!isEditable}
                          style={{ width: "280px", height: "32px" }}
                        >
                          <Option value="">No</Option>
                          <Option value="yes">Yes</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </div>
                )}

                {this.props.randomizationConfirmStep && (
                  <Col md={24}>
                    <label>
                      <b>{this.props.i18n.t("Password*")}</b>
                      <Form.Item>
                        {getFieldDecorator("password", {
                          rules: [
                            {
                              required: this.state.showConfirmModal,
                            },
                          ],
                        })(<Input.Password disabled={!isEditable} />)}
                      </Form.Item>
                    </label>
                  </Col>
                )}

                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={(e) => {
                    if (this.props.randomizationConfirmStep) {
                      this.props.form.validateFields(async (err, data) => {
                        if (!err) {
                          this.handleSubmit(e);
                        }
                      });
                    }
                  }}
                >
                  {this.props.saveButton || "Save"}
                </Button>

                <div>
                  {this.state.requestResult &&
                    this.state.requestResult.type === "error" &&
                    this.state.requestResult.message && (
                      <Alert
                        type="error"
                        message={this.state.requestResult.message}
                        style={{ margin: "10px 0 0" }}
                      />
                    )}
                </div>
              </Modal>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  randomizationConfirmStep: getRandomizationConfirmStep(state),
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "FormBuilderCustomView" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(FormBuilderCustomView))
);



// WEBPACK FOOTER //
// ./src/containers/FormBuilder/FormBuilderCustomView.js